<template>
  <div>
    <div class="search-wrapper active">
      <div class="input-holder">
        <form @submit.prevent="search">
          <input type="text" v-model.trim="query" class="search-input" placeholder="Order nr"/>
          <button class="search-icon"><span></span></button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import OrderFilterSet from "../models/OrderFilterSet";
// import OrderListColumns from "./OrderListColumns";

export default {
    name: "QuickOrderSearch",

    data() {
        return {
            query: '',
        }
    },

    computed: {},

    methods: {
        search() {
            let newSearchParams = OrderFilterSet
            newSearchParams.order_identifier = this.query
            newSearchParams.isCollapsed = true

            this.$store.commit('setOrderQuickSearchQuery', this.query);

            let orderSearchRoute = {
                name: 'FrontendFilterOrderSearch',
            }

            if (this.$router.resolve(orderSearchRoute).resolved.fullPath !== this.$router.currentRoute.fullPath) {
                this.$router.push(orderSearchRoute)
            }
            else {
                this.$root.forceReloadRouterView++
            }

            this.query = ''
        },
    },
}
</script>
